<template>
	<fixed-header class="navbar" v-click-outside="closeNavs">
		<div class="global-nav-container navbar" :class="{ 'partners-page-nav' : this.$route.solidNav }">
			<div class="desktop-nav">
				<div class="nav-inner">
					<div class="main-logo-links flex-row">
						<img src="@/assets/img/logos/logo.svg" alt="" @click="$router.push('/'); closeNavs()">
						<p class="nav-link drop-link" :class="{ 'active' : featuresToggle }" @click="resourcesHide()">features</p>
						<router-link to="/pricing" class="nav-router">
							<p class="nav-link" @click="closeNavs()">pricing</p>
						</router-link>
						<router-link to="/partners" class="nav-router">
							<p class="nav-link" @click="closeNavs()">partners</p>
						</router-link>
						<router-link to="/resources/blog" class="nav-router">
							<p class="nav-link" @click="closeNavs()">blog</p>
						</router-link>
						<!-- <p class="nav-link drop-link"  :class="{ 'active' : resourcesToggle }" @click="featuresHide()">resources</p> -->
					</div>
					<div class="nav-actions flex-row justify-end">
						<!-- <router-link to="app-login" class="nav-router" target="_blank">
							<p class="nav-link" @click="closeNavs()">login</p>
						</router-link> -->
						<router-link to="/book-a-demo" class="nav-router">
							<button class="nav-btn inverted" @click="closeNavs()">book&nbsp;a&nbsp;demo</button>
						</router-link>
					</div>
				</div>
				<!-- FEATURES TAKEOVER -->
				<transition name="fade" mode="out-in">
					<div class="dropdown-list features" v-show="featuresToggle">
						<div class="dropdown-inner flex-row align-start">
							<div class="one-quarter feature-box" @click="$router.push('/features/recognition'); featuresToggle = !featuresToggle">
								<img src="@/assets/img/icons/nav/recognition-icon.svg" alt="" class="feature-icon">
								<h2 class="feature-heading">Recognition</h2>
								<p class="feature-copy">Recognize and motivate great work by sending quick peer, team and manager awards right from the dashboard.</p>
							</div>
							<div class="one-quarter feature-box" @click="$router.push('/features/rewards'); featuresToggle = !featuresToggle">
								<img src="@/assets/img/icons/nav/rewards-icon.svg" alt="" class="feature-icon">
								<h2 class="feature-heading">Rewards</h2>
								<p class="feature-copy">Redeem awards for amazing merchandise, gift card and travel experiences from the world’s best loved brands.</p>
							</div>
							<div class="one-quarter feature-box" @click="$router.push('/features/trees'); featuresToggle = !featuresToggle">
								<img src="@/assets/img/icons/nav/trees-icon.svg" alt="" class="feature-icon">
								<h2 class="feature-heading">Trees</h2>
								<p class="feature-copy">Create real change with every employee action funding tree planting and forest conservation around the globe.</p>
							</div>
							<div class="one-quarter feature-box">
								<img src="@/assets/img/icons/nav/incentives-icon.svg" alt="" class="feature-icon">
								<h2 class="feature-heading">Incentives</h2>
								<p class="feature-copy">Motivate your teams to achieve sales targets and other mission critical KPIs with goal tracking and performance rewards.</p>
								<p class="coming-soon-pill">coming soon</p>
							</div>
						</div>
					</div>
				</transition>
				<!-- END FEATURES TAKEOVER -->
				<!-- RESOURCES TAKEOVER -->
				<transition name="fade">
					<div class="dropdown-list resources" v-show="resourcesToggle">
						<div class="dropdown-inner flex-row align-start">
							<div class="one-quarter feature-box" @click="$router.push('/resources/blog'); resourcesToggle = !resourcesToggle">
								<img src="@/assets/img/icons/nav/blog-icon.svg" alt="" class="feature-icon">
								<h2 class="feature-heading">Blog</h2>
								<p class="feature-copy">Stay up to date with the very latest Evergrow features, rewards, tree planting projects, environmental milestones and much more.</p>
							</div>
							<div class="one-quarter feature-box" @click="$router.push('/resources/library'); resourcesToggle = !resourcesToggle">
								<img src="@/assets/img/icons/nav/library-icon.svg" alt="" class="feature-icon">
								<h2 class="feature-heading">Library</h2>
								<p class="feature-copy">This growing collection of useful assets will help you discover more about our community and climate impact, and more.</p>
							</div>
							<div class="one-quarter feature-box" @click="$router.push('/resources/news'); resourcesToggle = !resourcesToggle">
								<img src="@/assets/img/icons/nav/news-icon.svg" alt="" class="feature-icon">
								<h2 class="feature-heading">News</h2>
								<p class="feature-copy">Evergrow is in the news! Read our latest Press Releases and media appearances right here.</p>
							</div>
							<div class="one-quarter placeholder"></div>
						</div>
					</div>
				</transition>
				<!-- END RESOURCES TAKEOVER -->
			</div>
			<MobileNav />
		</div>
	</fixed-header>
</template>

<script>
	import FixedHeader from "vue-fixed-header";
	import MobileNav from '@/components/MobileNav.vue'

	export default {
		data() {
			return {
				featuresToggle: false,
				resourcesToggle: false,
				mobileNavToggle: false,
				mobileNavFeaturesToggle: false,

			}
		},
		components: {
			FixedHeader,
			MobileNav
		},
		methods: {
			featuresHide() {
				if (this.featuresToggle) {
					this.featuresToggle = false;
				}
				this.resourcesToggle = !this.resourcesToggle;
			},
			resourcesHide() {
				if (this.resourcesToggle) {
					this.resourcesToggle = false;
				}
				this.featuresToggle = !this.featuresToggle;
			},
			closeNavs() {
				this.featuresToggle = false;
				this.resourcesToggle = false;
				this.mobileNavFeaturesToggle = false;
				this.mobileNavToggle = false;
			}
		},
	}
</script>

<style lang="stylus">

	.global-nav-container
		position fixed
		top 0
		z-index 1000
		height auto
		width 100%
		background-color transparent
		box-shadow none
		transition all 0.35s linear
		
		&.vue-fixed-header--isFixed
			background-color #fff
			box-shadow rgba(0, 0, 0, 0.05) 0px 14px 30px	
		&.partners-page-nav
			background-color #fff !important
			box-shadow rgba(0, 0, 0, 0.05) 0px 14px 30px !important
			transition-delay 0.5s
	.desktop-nav
		z-index 991
	.nav-inner
		position relative
		z-index inherit
		width 90%
		max-width 1300px
		margin 0 auto
		padding 38px 0 30px
		display flex
		flex-direction row
		justify-content space-between
		align-items center
		
	.main-logo-links
		width 60%
		
		img
			cursor pointer
			position relative
			top -8px
		
	.nav-actions
		width 25%
		
	.nav-actions .nav-link,
	.nav-link:not(:last-of-type)
		margin-right 10px
		
	a.nav-router
		text-decoration none
		display block
		margin-right 10px
		transition color 0.125s ease
		
		&.router-link-exact-active p
			color #00A562 !important
	
	.nav-link 
		position relative
		text-transform uppercase
		font-size 15.5px
		font-weight 300
		letter-spacing 0.6px
		line-height 1
		padding-bottom 0
		cursor pointer
		transition color 0.125s ease
		
		&.drop-link
			position relative 
			top 0
			transition all 0.25s ease-out

		
		&.drop-link:after
			content '>'
			position absolute
			top -2px
			right -16px
			font-size 20px
			transform rotate(90deg)
			transform-origin center
			transition all 0.125s ease
		&.drop-link.active:after
			transform rotate(270deg)
			
		&:hover
			color #00A562
			
		&.active
			color #00A562
			
		&.drop-link:hover 
			top -5px
			
	.nav-btn
		font-size 15.5px
		white-space nowrap
			
	.dropdown-list
		position absolute
		top 0
		z-index 990
		width 100%
		background-color #fff
		padding 140px 0 60px
		box-shadow 0px 20px 40px #00000033
	
	.dropdown-list .dropdown-inner
		width 90%
		max-width 1300px
		margin 0 auto
		
	.dropdown-list .feature-box
		cursor pointer
		
	.dropdown-list .feature-icon
		height 50px 
		margin-bottom 20px
		
	.dropdown-list .feature-heading
		font-family baskerville-urw, serif
		font-size 34px
		font-weight 400
		letter-spacing 0.6px
		line-height 1	
		margin-bottom 10px
		
	.dropdown-list .feature-copy
		font-size 13px
		font-weight 300
		line-height 1.5
		margin-bottom 20px
		
	.coming-soon-pill
		border 1px solid #ccc
		border-radius 25px
		width -moz-fit-content
		width fit-content
		padding 6px 14px
		font-size 10px
		text-transform uppercase
		letter-spacing 0.6px
		color #ccc
		
	@media ( max-width: 1100px )
		.desktop-nav
			display none
</style>